// @flow
/* eslint-disable no-shadow */
import React from 'react';
import * as Sentry from '@sentry/react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import { withTranslation } from 'react-i18next';
import ExitToAppOutlinedIcon from '@material-ui/icons/ExitToAppOutlined';
import { logoutAndClean } from '../../utils/user';
import { styles } from '../../modules/scribe/SidebarHelpers';
import { clearScribeConversationState, firebaseLogout, loggingOut } from '../../actions';

function LogOut({
  classes,
  clearScribeConversationState,
  loggingOut,
  t,
  firebaseLogout,
  firebaseUser,
}: {
  classes: Object,
  clearScribeConversationState: Function,
  loggingOut: Function,
  t: Object,
  firebaseLogout: Function,
  firebaseUser: Object,
}) {
  return (
    <ListItem
      button
      onClick={async () => {
        loggingOut();
        await logoutAndClean();
        clearScribeConversationState();
        firebaseLogout();
        Sentry.configureScope(scope => {
          scope.setUser(null);
        });
        window.history.pushState({}, document.title, firebaseUser?.isAnonymous ? '/web/login' : '/web');
        window.location.reload();
      }}
    >
      <ListItemIcon>
        <ExitToAppOutlinedIcon />
      </ListItemIcon>
      <ListItemText
        classes={{ root: classes.listItemText }}
        primary={firebaseUser?.isAnonymous ? t('sidebar.signIn') : t('sidebar.signOut')}
      />
    </ListItem>
  );
}

const mapStateToProps = ({ firebase: { user } }) => ({
  firebaseUser: user,
});

export default connect(mapStateToProps, {
  clearScribeConversationState,
  firebaseLogout,
  loggingOut,
})(withTranslation()(withStyles(styles, { withTheme: true })(LogOut)));
